import dayjs from 'dayjs';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { deleteCalendarBlockRoute, eventsInterviewKey, eventsKey } from '@features/enterpriseEvents';
import axiosInstance from '@server/axiosInstance';

type UseDeleteCalendarBlockProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  interviewBlockStartTime: number;
};

export const useDeleteCalendarBlock = ({
  setErrorText = () => { },
  interviewBlockStartTime,
}: UseDeleteCalendarBlockProps) => {
  const client = useQueryClient();

  const { mutate: deleteCalendarBlock, isLoading: isDeletingCalendarBlock } =
    useMutation({
      mutationFn: (variables: { calendar_block_id: number }) =>
        axiosInstance
          .post(deleteCalendarBlockRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          client.invalidateQueries(eventsKey);
          client.invalidateQueries(eventsInterviewKey);
          setErrorText('');
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    deleteCalendarBlock,
    isDeletingCalendarBlock,
  };
};
